import { Component, OnInit } from '@angular/core';
import { SaleService } from '../sale.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sale-list-items',
  templateUrl: './sale-list-items.component.html',
  styleUrls: ['./sale-list-items.component.css'],
  providers: [SaleService]
})
export class SaleListItemsComponent implements OnInit {

  sale: any;
  saleItems: any = [];
  saleItemId: any = "";
  loadingSaleItem: boolean = true;
  public applyFormDisplay: boolean = false;
  private id: string;
  public title: string = "Проданные товары";



  constructor(
    private saleService: SaleService, 
    public global: GlobalDataService,
    private _location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router) {

      this.sale = {status : {id : null}, contractor : {name : null}};
      
      this.activatedRoute.params.subscribe(params=>{this.id=params['id']});

      this.loadSaleById(this.id);

      this.getItemListBySaleId(this.id);

     }

  ngOnInit() {
  }

 loadSaleById(saleId: string){
    this.saleService.getSaleById(saleId).subscribe(response=>{
      this.sale = response['data'];
      this.title = this.title + " - " + this.sale.invoice_number + " ("+this.sale.status.name+")";
    })
 }

 getItemListBySaleId(saleId: any) {
    // this.sale = sale;
    this.saleItemId = this.sale.id;
    this.saleItems = [];
    this.loadingSaleItem = true;
    this.saleService.getSaleItemListByIdService(saleId).subscribe(response => {
      this.saleItems = response['data'];
      this.loadingSaleItem = false;
    })
  }

  
  print() {
    this.saleService.printSale(this.sale.id).subscribe(response => { window.open(response['data'].link); });
  }

  printReview(){
    this.saleService.printSaleReview(this.sale.id).subscribe(response => { window.open(response['data'].link); });
  }

  onApplyInprocessingSale() {
    this.applyFormDisplay = false;
    this.saleService.applyInprocessingSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleById(this.id);
    });
  }

  onApplyFinishSale() {
    this.applyFormDisplay = false;
    this.saleService.applyFinishSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleById(this.id);
    });
  }
  onApplyAcceptedSale() {
    this.applyFormDisplay = false;
    this.saleService.applyAcceptedSale({ id: this.sale.id }).subscribe(response => {
      this.loadSaleById(this.id);
    });
  }
  ReCreate(){
    this.router.navigate(['/dashboard/sale-update/', { contractor_id: this.sale.contractor.id, from_type: "sale_update", id: this.id }])
  }

  onShowApplyDisplay(type: number) {
    switch (type) {
      case 1:

        break;
      case 2:

        break;
    }

    this.applyFormDisplay = true;
  }

  backClicked() {
    this._location.back();
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale-list-items/sale-list-items.component.ts